/*
 * File: 客户经理看板-收入预测-版本管理
 */
<template>
    <div class="revenue-version">
        <Paper class="revenue-version-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="versionList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        size="mini"
                        title="新增"
                        icon="el-icon-plus"
                        @click="handleAdd">新增
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="versionList.getList()"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" content="列配置" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" @click="handleColumnConfig" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="versionList.tableLoading"
                        :key="rendertable"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="versionList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="false"
                        :allowRowClickFunc="config.rowDbClickFun"
                        :editDisableRule="config.disableEditFun"
                        @row-db-click="handleLink"
                        @element-change="handleChangeRow"
                        @btn-event="handleActive"
                    >
                        <template #col-header="{ item }">
                            {{ item.label }}
                            <el-tooltip v-if="item.tooltip" :content="item.tooltip" placement="top">
                                <i style="color: #5cb6ff; font-size: 14px" class="el-icon-info" />
                            </el-tooltip>
                        </template>
                        <template #col-append="{item, row}">
                            <!-- 预测版本 -->
                            <span
                                v-if="item.prop === 'forecastVersionCode'"
                                size="mini"
                                type="text"
                                :class="![0, 1].includes(+row.versionStatus) ? 'revenue-version-link' : ''"
                                @click="handleLink(row)"
                            >{{ row.forecastVersionCode }}</span>
                            <!-- 状态 -->
                            <span v-if="item.prop === 'versionStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                        </template>
                        <template #edit-col-append="{ item, row }">
                            <span v-if="item.prop === 'forecastVersionCode'">{{ row.forecastVersionCode }}</span>
                            <el-select v-if="item.prop === 'rollMonths' " v-model="row[item.prop]" :disabled="row.rollMonthsDisabled" @change="handleRendertable">
                                <el-option
                                    v-for="it in rollMonthsOptions"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                            <span v-if="item.prop === 'versionStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey])}}</span>
                        </template>
                    </edit-table-box>

                    <!-- 表格列配置弹框 -->
                    <column-config
                        ref="columnConfigRef"
                        :pageID="config.name"
                        :initColumns="config.columns"
                        @header-change="config.columns = $event"
                    />
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="versionList.sizeChange"
                        :current-page.sync="versionList.pageNo"
                        @current-change="versionList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="versionList.pageTotal"
                    />
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated, getCurrentInstance } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import columnConfig from '@/components/lots/columnConfig/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getRevenueVersionPage, getRevenueVersionByMonth, revenueVersionAdd, revenueVersionUpdate, revenueVersionSubmit } from '@mdm/api/customer/revenueVersion.js';
import { config as configStatic } from './config';

export default {
    name: 'revenueVersion',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        editTableBox,
        lotsPagination,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.revenueVersion);
        const { user } = store.getters;
        const ctx = getCurrentInstance();
        const config = reactive(configStatic);
        const dictDatas = ref({});
        const rollMonthsOptions = ref([]);
        const rendertable = ref(1);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            edit: -3,
                            allowEdit: true,
                            ...v,
                            versionStatus: v.versionStatus?.toString()
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const versionList = new AccountListClass({
            Api: {
                listApi: getRevenueVersionPage // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.createTimeFixed) {
                condition.createTimeStart = utils.formatDateTime(condition.createTimeFixed[0]);
                condition.createTimeEnd = utils.formatDateTime(condition.createTimeFixed[1]);
                Reflect.deleteProperty(condition, 'createTimeFixed');
            }

            const newParams = { ...condition, ...params, userCode: user.userCode };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 刷新表格
        const handleRendertable = () => {
            rendertable.value++;
        };
        // 跳转到收入预测页面
        const handleLink = (row) => {
            // 状态≠草稿/跑数中，可跳转
            if ([0, 1].includes(+row.versionStatus)) return;
            ctx.$router.push({ path: '/mod/mdm/revenue-forecast', query: { version: row.forecastVersionCode, periodMonth: row.periodMonth } });
        };
        // 新增
        const handleAdd = () => {
            versionList.totalData.value.unshift({
                edit: 2,
                allowEdit: true,
                versionStatus: '0', // 草稿
                rollMonthsDisabled: false
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 列配置
        const handleColumnConfig = () => {
            setupContext.refs.columnConfigRef.show(true);
        };
        // 表格内表单元素发生变化时回调
        const handleChangeRow = async ({ prop, val, row }) => {
            if (prop === 'periodMonth') {
                row.rollMonths = '';
                row.rollMonthsDisabled = false;
                if (val) {
                    // 当存在同预测年月的版本时，自动按V1版本的滚动预测月数带出并只读
                    const { data } = await getRevenueVersionByMonth({ periodMonth: val });
                    if (data && data.length) {
                        row.rollMonths = data.find((v) => v.forecastVersionCode === 'V1')?.rollMonths;
                        row.rollMonthsDisabled = true;
                    }
                }
                handleRendertable();
            }
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                handleRendertable();
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
            // 审核
            if (event === 'verify') {
                handleVerify(row);
            }
        };
        // 保存
        const handleSave = async (row) => {
            const { code } = row.id ? await revenueVersionUpdate(row) : await revenueVersionAdd(row);
            if (+code === 0) {
                Message.success('保存成功');
                versionList.getList();
            }
        };
        // 审核
        const handleVerify = (row) => {
            MessageBox.confirm('审核后将触发生成版本，请确认！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const { code } = await revenueVersionSubmit(row);
                    if (+code === 0) {
                        Message.success('审核成功');
                        versionList.getList();
                    }
                });
        };

        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async() => {
            setupContext.refs.searchBox.submitSearch();
            const { data } = await getDictDataApi({ dictCodes: 'CRM_FORECAST_VERSION_STATUS' });
            dictDatas.value = data || {};

            // 设置滚动预测月数下拉项
            const number = 12;
            for (let i = 3; i <= number; i++) {
                rollMonthsOptions.value.push({ label: i, value: i });
            }
        });
        return {
            versionList,
            config,
            authorityCode,
            dictDatas,
            rollMonthsOptions,
            rendertable,
            formatDictCodeToName,
            handleRendertable,
            handleLink,
            handleAdd,
            handleColumnConfig,
            handleChangeRow,
            handleActive
        };
    }
};
</script>

<style lang="less">
.revenue-version {
    width: 100%;
    .revenue-version-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.revenue-version-paper {
        padding: 0px 0px 0px;
    }
    .revenue-version-link {
        color: #4285f5;
        cursor: pointer;
    }
    .edit-table-box .el-select, .edit-table-box .el-date-editor {
        width: 100%;
    }
}
</style>
